export default "__VITE_ASSET__8d605b4f__"